module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc){
  var lines = str.split('\n');
  var start = Math.max(lineno - 3, 0);
  var end = Math.min(lines.length, lineno + 3);
  var filename = esc(flnm); // eslint-disable-line
  // Error context
  var context = lines.slice(start, end).map(function (line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
};
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
var __line = 1
  , __lines = "<%\nconst data = rowResourceData || {}\nconst attributes = data.attributes || {}\nconst status = attributes.status || 'notAvailable'\nconst notInfo = attributes.notInfo || {}\nconst flags = {\n// info, ok, error\noffer:          attributes.offerSent           ? 'ok' : (notInfo.offer ? 'error' : 'info'),\nconfirmation:   attributes.confirmationSent    ? 'ok' : (notInfo.confirmation ? 'error' : 'info'),\ndriveOrder:     attributes.driveOrderIssued    ? 'ok' : (notInfo.driveOrder ? 'error' : 'info'),\ninvoice:        attributes.invoiceSent         ? 'ok' : (notInfo.invoice ? 'error' : 'info'),\n}\n%><div><%\n%><div class=\"status\"><%\n%><%= storage.__(`trips.status.${status}`) %><%\n%></div><%\n%><div class=\"flags\"><%\nfor(const [flag, severity] of Object.entries(flags)){\n%><div class=\"severity_<%- severity %>\" title=\"<%= storage.__(`trips.status.flagTitle.${flag}.${severity}`) %>\">&nbsp;</div><%\n}\n%></div><%\n%></div>"
  , __filename = "components/templates/office/trips/tableFields/statusSummary.ejs";
try {
  var __output = "";
  function __append(s) { if (s !== undefined && s !== null) __output += s }
  with (locals || {}) {
    ; 
const data = rowResourceData || {}
const attributes = data.attributes || {}
const status = attributes.status || 'notAvailable'
const notInfo = attributes.notInfo || {}
const flags = {
// info, ok, error
offer:          attributes.offerSent           ? 'ok' : (notInfo.offer ? 'error' : 'info'),
confirmation:   attributes.confirmationSent    ? 'ok' : (notInfo.confirmation ? 'error' : 'info'),
driveOrder:     attributes.driveOrderIssued    ? 'ok' : (notInfo.driveOrder ? 'error' : 'info'),
invoice:        attributes.invoiceSent         ? 'ok' : (notInfo.invoice ? 'error' : 'info'),
}

    ; __line = 13
    ; __append("<div>")
    ; 

    ; __line = 14
    ; __append("<div class=\"status\">")
    ; 

    ; __line = 15
    ; __append(escapeFn( storage.__(`trips.status.${status}`) ))
    ; 

    ; __line = 16
    ; __append("</div>")
    ; 

    ; __line = 17
    ; __append("<div class=\"flags\">")
    ; 
for(const [flag, severity] of Object.entries(flags)){

    ; __line = 19
    ; __append("<div class=\"severity_")
    ; __append( severity )
    ; __append("\" title=\"")
    ; __append(escapeFn( storage.__(`trips.status.flagTitle.${flag}.${severity}`) ))
    ; __append("\">&nbsp;</div>")
    ; 
}

    ; __line = 21
    ; __append("</div>")
    ; 

    ; __line = 22
    ; __append("</div>")
  }
  return __output;
} catch (e) {
  rethrow(e, __lines, __filename, __line, escapeFn);
}

//# sourceURL=components/templates/office/trips/tableFields/statusSummary.ejs

}